import { CUSTOM_ELEMENTS_SCHEMA, isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  HttpClient,
} from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ReactiveFormsModule } from '@angular/forms';
import { NotifierModule } from 'angular-notifier';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import {
  TranslateLoader,
  TranslateModule,
  TranslationObject,
} from '@ngx-translate/core';

import * as TranslationsFA from '../assets/i18n/fa.json';
import { Observable, of } from 'rxjs';
import { providePrimeNG } from 'primeng/config';
import AfraTheme from './theme.preset';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

interface Translation {
  [key: string]: TranslationObject;
}

const TRANSLATIONS: Translation = {
  fa: TranslationsFA,
};

export class StaticTranslationLoader implements TranslateLoader {
  public getTranslation(lang: string): Observable<TranslationObject> {
    const translation = TRANSLATIONS[lang];
    if (translation) {
      return of(translation);
    } else {
      console.error(`Unknown language: ${lang}`);
      return of({});
    }
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    LayoutModule,
    BlockUIModule,
    ProgressSpinnerModule,
    NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'middle',
          distance: 12,
        },
        vertical: {
          position: 'top',
          distance: 56,
          gap: 10,
        },
      },
    }),
    ServiceWorkerModule.register('/custom-sw.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:15000',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: StaticTranslationLoader,
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    providePrimeNG({
      theme: {
        preset: AfraTheme,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// TODO 5 columns in all workshop lists
// TODO videos before afra magazine
